module.exports = __webpack_public_path__ + "media/images/Glydsphere_logo-f7df3dce7da28b13bc69da6e7d718aa7accba43aa6c0a1162b4a66706b9d2519.png";